export enum ConfigurationSectionTypeEnum {
    GENERAL =       0,  // -> 0
    ACTION =        1,  // -> 1
    MACHINE_ROOM =  2,  // -> 2
}
